// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en/translationEN.json";
import translationFR from "./locales/fr/translationFR.json";
import translationTR from "./locales/tr/translationTR.json";
import translationDE from "./locales/de/translationDE.json";
import translationES from "./locales/es/translationES.json";
import translationPT from "./locales/pt/translationPT.json";
import translationNL from "./locales/nl/translationNL.json";
import translationIT from "./locales/it/translationIT.json"; // Italian

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  tr: { translation: translationTR },
  de: { translation: translationDE },
  es: { translation: translationES },
  pt: { translation: translationPT },
  nl: { translation: translationNL },
  it: { translation: translationIT },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("ln") || "en",
  fallbackLng: "en",
  keySeparator: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
